import React from 'react';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';
import Tooltip from '@spark/ui-components/components/Tooltip';
import { formatarValorBRL } from '@spark/utils/formatters';

export const getTabelaPremiacaoColumns = (onEdit, onDelete, loadingEditId, loadingDeleteId) => [
  {
    id: 'id',
    accessorKey: 'id',
    header: 'ID',
    size: 80,
    cell: ({ row }) => row.original.id ?? '-'
  },
  {
    id: 'nome',
    accessorKey: 'nome',
    header: 'Nome',
    size: 200,
    cell: ({ row }) => row.original.nome || '-'
  },
  {
    id: 'segmento',
    accessorKey: 'segmento',
    header: 'Segmento',
    size: 140,
    cell: ({ row }) => row.original.segmento || '-'
  },
  {
    id: 'valorInicioFaturamento',
    accessorKey: 'valorInicioFaturamento',
    header: 'Fat. Início',
    size: 120,
    cell: ({ row }) => {
      const value = row.original.valorInicioFaturamento;
      return value === null || value === undefined ? '-' : formatarValorBRL(value);
    }
  },
  {
    id: 'valorFinalFaturamento',
    accessorKey: 'valorFinalFaturamento',
    header: 'Fat. Final',
    size: 120,
    cell: ({ row }) => {
      const value = row.original.valorFinalFaturamento;
      return value === null || value === undefined ? '-' : formatarValorBRL(value);
    }
  },
  {
    id: 'mediaIdeal',
    accessorKey: 'mediaIdeal',
    header: 'Média Ideal',
    size: 110,
    cell: ({ row }) => row.original.mediaIdeal ?? '-'
  },
  {
    id: 'mediaExcelente',
    accessorKey: 'mediaExcelente',
    header: 'Média Excelente',
    size: 120,
    cell: ({ row }) => row.original.mediaExcelente ?? '-'
  },
  {
    id: 'valorPremiacao',
    accessorKey: 'valorPremiacao',
    header: 'Valor Premiação',
    size: 130,
    cell: ({ row }) => {
      const value = row.original.valorPremiacao;
      return value === null || value === undefined ? '-' : formatarValorBRL(value);
    }
  },
  {
    id: 'ativo',
    accessorKey: 'ativo',
    header: 'Ativo',
    size: 80,
    cell: ({ row }) => (row.original.ativo === true ? 'Sim' : 'Não')
  },
  {
    id: 'acoes',
    header: 'Ações',
    size: 120,
    cell: ({ row }) => (
      <div style={{ display: 'flex', gap: 8 }}>
        <Tooltip dir="top" text="Editar">
          <span className="d-inline-block">
            <ButtonWithLoading
              variant="outline-primary"
              size="sm"
              loading={loadingEditId === row.original.id}
              disabled={loadingEditId === row.original.id}
              onClick={(event) => {
                event.stopPropagation();
                onEdit(row.original.id);
              }}
            >
              <Icon name="pencil" size={16} />
            </ButtonWithLoading>
          </span>
        </Tooltip>
        <Tooltip dir="top" text="Excluir">
          <span className="d-inline-block">
            <ButtonWithLoading
              variant="outline-danger"
              size="sm"
              loading={loadingDeleteId === row.original.id}
              disabled={loadingDeleteId === row.original.id}
              onClick={(event) => {
                event.stopPropagation();
                onDelete(row.original.id);
              }}
            >
              <Icon name="trash" size={16} />
            </ButtonWithLoading>
          </span>
        </Tooltip>
      </div>
    ),
    enableSorting: false
  }
];
